/**
 * LAZY LOADING VERSION
 * import in Gallery.js has changed
 * getDirectInfos in Puzzle2.js for popup and draggable popup
 */
export default class InfiniteGallery {
  constructor(scope, parent, assets, res) {
    this.scope = scope;
    this.parent = parent;
    this.assets = assets;
    this.resolution = res;

    this.width = this.parent.getBoundingClientRect().width;
    this.height = this.parent.getBoundingClientRect().height;
    this.divider = this.width < 820 ? 2 : 5;
    this.divider2 = 5;
    this.margin = 5;
    this.imageKEYCounter = 0;
    this.setup();
  }

  setup() {
    if (!this.imagesKeys) this.imagesKeys = Object.keys(this.assets);
    const w =
      (this.width - this.divider * 2 * this.margin - 2 * this.margin) /
      this.divider;
    let count = 0;
    for (const id of this.imagesKeys) {
      const asset = this.assets[id];
      const h = asset.height * (w / asset.width);
      const div = document.createElement("div");
      div.classList.add("slideshow", "show");
      div.style.position = "absolute";
      div.style.backgroundSize = "105%";
      div.style.width = Math.floor(w) + "px";
      div.style.height = Math.floor(h) + "px";
      div.id = count;
      div.setAttribute("data-url", asset.url);
      div.setAttribute("asset-id", asset.id);
      div.setAttribute("data-width", asset.width);
      div.setAttribute("data-height", asset.height);
      this.parent.appendChild(div);
      count++;
    }
    this.parent.addEventListener("click", this.scope.initGameHandler);
    this.layout();
    this.showVisible();
    this.initScrolling();
  }

  showVisible() {
    for (const item of this.parent.getElementsByClassName("slideshow")) {
      const top = item.getBoundingClientRect().top;
      const bottom = item.getBoundingClientRect().bottom;
      const w = item.getBoundingClientRect().width;
      const h = item.getBoundingClientRect().height;
      if (top < window.innerHeight && bottom > 0) {
        item.style.backgroundImage =
          "url(" +
          item.getAttribute("data-url") +
          "=s" +
          Math.round(Math.min(w > h ? w : h, 512)) +
          ")";
        /** IE11 FIX */
        item.style.opacity = 1;
      } else {
        // item.style.backgroundImage = 'none';
      }
    }
  }

  layout() {
    const margin = this.margin;
    const startMargin = document.querySelector(".subtitle")
      ? document.querySelector(".subtitle").getBoundingClientRect().height
      : 3;
    const itemWidth =
      (this.width - this.divider * 2 * this.margin - 2 * this.margin) /
      this.divider;
    const containerWidth = this.width;
    const columnCount = Math.floor(
      (containerWidth - margin) / (itemWidth + margin)
    );
    const columnsHeight = [startMargin];
    let columnIndex = 0;

    let lastItem = null;
    let lastItemY = 0;

    for (const item of this.parent.getElementsByClassName("slideshow")) {
      if (columnsHeight.length == columnIndex) {
        columnsHeight.push(startMargin);
      }
      item.style.left = `${columnIndex * (itemWidth + 2 * margin) + margin}px`;
      item.style.top = `${columnsHeight[columnIndex]}px`;
      item.style.marginBottom = "0";
      columnsHeight[columnIndex] += item.offsetHeight + 2 * margin;

      if (columnsHeight[columnIndex] > lastItemY) {
        lastItem = item;
        lastItemY = columnsHeight[columnIndex];
      }
      if (columnsHeight.length < columnCount) {
        columnIndex++;
        if (columnIndex >= columnCount) {
          columnIndex = 0;
        }
      } else {
        let minHeight = Number.MAX_SAFE_INTEGER;
        let i = 0;
        for (const columnsH of columnsHeight) {
          if (columnsH < minHeight) {
            minHeight = columnsH;
            columnIndex = i;
          }
          i++;
        }
      }
    }
    if (lastItem) {
      lastItem.style.marginBottom = "70px";
    }
  }

  update() {
    this.width = this.parent.getBoundingClientRect().width;
    this.height = this.parent.getBoundingClientRect().height;
    this.divider = this.width < 820 ? 2 : 5;
    const images = this.parent.getElementsByClassName("slideshow");
    const w =
      (this.width - this.divider * 2 * this.margin - 2 * this.margin) /
      this.divider;
    for (const image of images) {
      const h =
        image.getAttribute("data-height") *
        (w / image.getAttribute("data-width"));
      image.style.width = Math.floor(w) + "px";
      image.style.height = Math.floor(h) + "px";
    }
    this.layout();
    this.showVisible();
  }

  initScrolling() {
    this.isScrolling;
    // Listen for scroll events
    this.parent.addEventListener(
      "scroll",
      (event) => {
        // Clear our timeout throughout the scroll
        clearTimeout(this.isScrolling);

        // Set a timeout to run after scrolling ends
        this.isScrolling = setTimeout(() => {
          // Run the callback
          // console.log(
          //   "Scrolling has stopped.",
          //   this.parent.scrollTop,
          //   this.parent.scrollHeight,
          //   this.parent.getBoundingClientRect().height,
          //   this.parent.scrollHeight - this.parent.scrollTop
          // );
          if (
            this.parent.scrollHeight -
              this.parent.scrollTop -
              this.parent.getBoundingClientRect().height <
            70
          ) {
            this.loadMore();
          }
          this.showVisible();
        }, 66);
      },
      false
    );
  }

  /**
   * LAZY LOADING VERSION
   * loadMore() has changed
   */
  async loadMore() {
    // get the actual amount of loaded images
    const loadedImages = this.parent.getElementsByClassName("slideshow").length;
    // add 30 more images
    const nextMax = loadedImages + 30;

    if (this.lastLoaded >= nextMax) {
      return;
    }

    document.getElementById("progressbar").classList.remove("hidden");

    // get the next 30 images
    await fetch(
      `./gallery/${
        this.scope.customGallery || "list"
      }/${loadedImages}/${nextMax}`
    )
      .then((data) => data.json())
      .then((json) => {
        // this.NEW_DATA_FROM_OG = json;
        console.log("+++ DATA FOR THE GALLERY", json);
        this.addData2Assets(json);
        this.lastLoaded = nextMax;
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  addData2Assets(data) {
    const w =
      (this.width - this.divider * 2 * this.margin - 2 * this.margin) /
      this.divider;
    let count = this.parent.getElementsByClassName("slideshow").length;

    data.forEach((asset) => {
      if (!this.assets[asset.id]) {
        console.log("ok ? ");
        this.assets[asset.id] = asset;
        // this.imagesKeys.push(element.id);
        //  const asset = this.assets[id];
        const h = asset.height * (w / asset.width);
        const div = document.createElement("div");
        div.classList.add("slideshow", "show");
        div.style.position = "absolute";
        div.style.backgroundSize = "105%";
        div.style.width = Math.floor(w) + "px";
        div.style.height = Math.floor(h) + "px";
        div.id = count;
        div.setAttribute("data-url", asset.url);
        div.setAttribute("asset-id", asset.id);
        div.setAttribute("data-width", asset.width);
        div.setAttribute("data-height", asset.height);
        this.parent.appendChild(div);
        count++;
      }
    });
    document.getElementById("progressbar").classList.add("hidden");
    this.layout();
    this.showVisible();
  }
}
